import { NavDropdown } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../assets/aba/logo-aba.png'
import i18n from '../../i18n/index.js';
import { useTranslation } from 'react-i18next';
import flagEsp from '../../assets/logos/espana.png';
import flagUsa from '../../assets/logos/estados-unidos.png';
import flagChina from '../../assets/logos/china.png';

const styleNav = {
  textAlign: 'center'
};


function BasicExample() {

  const { i18n, t } = useTranslation();
  return (
    <Navbar expand="lg" className="bg-body-white">
      <Container>
        <Navbar.Brand href="/">
          <img
            src={logo}
            width="100"
            height="100"
            className="d-inline-block align-top"
            alt="Aba logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto" style={styleNav}>
            <Nav.Link href="/history">{t('institutional')}</Nav.Link>
            <Nav.Link href="/productFamily">{t('OurBrands')}</Nav.Link> 
            <Nav.Link href="/ecologicalCommitment">{t('EcoSustainableCommitment')}</Nav.Link>
            <Nav.Link href="/madeForYou">{t('MadeForYou')}</Nav.Link>
          </Nav>
          <hr/>
          <Nav className="ms-auto" style={styleNav}>
            {/* <NavDropdown title="Idioma" id="basic-nav-dropdown">
                <NavDropdown.Item onClick={() => {i18n.changeLanguage('es')}}>ESP</NavDropdown.Item>
                <NavDropdown.Item onClick={() => {i18n.changeLanguage('en')}}>
                  ENG
                </NavDropdown.Item>
                {/* <NavDropdown.Item href="#action/3.3">CHN</NavDropdown.Item>
              </NavDropdown> */}

      <Navbar.Brand onClick={() => {i18n.changeLanguage('es')}}>
                      <img
                        alt=""
                        src={flagEsp}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                      />{' '}
                      ESP
                    </Navbar.Brand> 
                    <Navbar.Brand onClick={() => {i18n.changeLanguage('en')}}>
                      <img
                        alt=""
                        src={flagUsa}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                      />{' '}
                      ENG
                    </Navbar.Brand> 
                    <Navbar.Brand onClick={() => {i18n.changeLanguage('zh')}}>
                      <img
                        alt=""
                        src={flagChina}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                      />{' '}
                      ZH
                    </Navbar.Brand> 
          </Nav>
          
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;